// extracted by mini-css-extract-plugin
export default {"wrapper":"FB-z","viewport":"GB-z","container":"HB-z","slide":"IB-z"};